import { ChatElement, ChatBundle } from '../../Service/ServerAPI';

export function groupMessagesWithIndex(messages: Array<ChatElement>): { 
    grouped: ChatBundle[], 
    indexedMessages: Array<{ message: ChatElement, index: number }> 
} {
    const grouped: ChatBundle[] = [];
    const indexedMessages: Array<{ message: ChatElement, index: number }> = [];
    let currentGroup: ChatBundle = {};
    let activeGroup: ChatBundle = {};
    let nextMessageRole: string = '';
    let nextMessageEndpoint: string = '';
    let correction: boolean = false;

    messages.forEach((message, index) => {
        // Counts the discrete message instances, used for grabbing subset 
        // of conversation for export context
        indexedMessages.push({ message, index });

        if (message.role === 'User' && message.endpoint === 'executeScript') {
            nextMessageRole = 'Tool';
            nextMessageEndpoint = '';
        } else if (message.role === 'User' && message.userInput) {
            currentGroup.request = message;
            nextMessageRole = 'Assistant';
            nextMessageEndpoint = 'chat';
        } else if (message.role === 'User' && message.courseCorrection) {
            nextMessageRole = 'Assistant';
            nextMessageEndpoint = 'chat';
            currentGroup.request = activeGroup.request;
            activeGroup = {};
            correction = true;
        } else if (message.role === 'Assistant') { // If there is an Assistant message without a user input
            currentGroup.response = message;
            nextMessageRole = 'User';
            nextMessageEndpoint = 'executeScript';
        } else if (message.role === 'Tool') {
            currentGroup.script = message;
            nextMessageRole = '';
        } else if (message.role === 'AssistantReasoning') {
            currentGroup.reasoning = message;
        }

        const nextMessage = messages[index + 1];

        if (
            (!nextMessage ||
            nextMessageRole !== nextMessage.role ||
            (nextMessageEndpoint !== '' &&
                nextMessageEndpoint !== nextMessage.endpoint)) &&
            message.role !== 'System' &&
            !(nextMessage && nextMessage.role === 'AssistantReasoning')
        ) {
            grouped.push(currentGroup);
            activeGroup = currentGroup;
            currentGroup = {};
            nextMessageRole = '';
            correction = false;
        }
    });

    return { grouped, indexedMessages };
}
